import { render } from "./ModalGeofence.vue?vue&type=template&id=9b065d72"
import script from "./ModalGeofence.vue?vue&type=script&lang=js"
export * from "./ModalGeofence.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__